/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StartDate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function StartDate({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/TreatmentPlans/Content/TreatmentPlan/Appointment/Appointment/Read/StartDate"
  
}) {
let treatmentPlanAppointmentsValueData = fromData.useDataValue({ viewPath,
context: 'treatment_plan',
path: 'appointments',
})
let appointmentIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'id',
})
let aggregateData = fromHelpers.calculateStartDate(treatmentPlanAppointmentsValueData, appointmentIdValueData)
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 marginLeft={dtSpaceXxs}
 data="treatment_plan.appointments"
 data="appointment.id"
 aggregate="helpers.js calculateStartDate"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}